import React from 'react';

import AddCoshhIcon from 'icons/ic-add-coshh.svg';
import { useTranslation } from 'react-i18next';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';

export default function ProjectCoshhBlankNotice() {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { coshhDocumentPolicy } = useProjectCoshhContext();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectCoshh.components.ProjectCoshhBlankNotice',
  });

  const { t: i18nTProjects } = useTranslation('common', {
    keyPrefix: 'projects',
  });

  return (
    <section className='section section--notice section--notice--no-top-border-radius tw-border-grey-100 tw-bg-white tw-px-20'>
      <AddCoshhIcon
        className='[&_path]:tw-fill-grey-500'
        height={42}
        width={42}
      />
      <h2 className='section__header tw-pt-0 tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nTProjects(
          coshhDocumentPolicy.canCreate ? 'coshh.addCoshh' : 'coshh.noCoshh',
        )}
      </h2>
      <p className='section__content tw-mb-0 tw-mt-2'>
        {i18nT(
          coshhDocumentPolicy.canCreate ?
            'creatableDescription'
          : 'readOnlyDescription',
          {
            interpolation: { escapeValue: false },
            singularRAMSName,
          },
        )}
      </p>
    </section>
  );
}
